import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../models/UiUtils';
import { THEME } from '../../components-v2/Theme/theme';
import { NAV_BAR_WIDTH_COMPACT } from '../../constants/sizes';
import {
	borderColor,
	brandPrimary,
	brandPrimaryHover,
	charmGray,
	darkGrayFontColor,
	gray4,
	green4,
	illusionYellow,
	prestoPurple,
	spanishBlue,
	titles,
	white,
} from '../../styles/colors';
import { CssSelectors, Layouts, cardStyle, ctaButtonReverseProps } from '../../styles/styles';

const suggestionsToggleContainerHeight = 62;
const suggestionsToggleContainerBottomPadding = 10;
const pendingApprovalAlertHeight = 50;
const pendingApprovalAlertBottomMargin = 10;
const pendingApprovalAlertBorderWidth = 1;

export const styleSheet = StyleSheet.create({
	rightSection: {
		marginLeft: 'auto',
		flex: 1,
	},
	calendarCardTabItemRightSection: {
		flex: 1,
	},
	pageRoot: {
		flex: 1,
		minWidth: THEME.breakpoints.lg - NAV_BAR_WIDTH_COMPACT,
	},
	calendar: {
		height: '100%',
	},
	calendarContainer: {
		width: `calc(100% - 22rem)`,
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 0%',
		paddingBottom: 2,
	},
	calendarContainerCard: {
		...cardStyle,
		flex: '1 1 0%',
		boxSizing: 'border-box',
		overflow: 'hidden',
		background: 'unset',
		border: 'none',
		boxShadow: 'none',
	},
	calendarContainerCardWithAlert: {
		height: `calc(100vh - ${200 + pendingApprovalAlertHeight + 2 * pendingApprovalAlertBorderWidth + pendingApprovalAlertBottomMargin}px)`,
	},
	calendarContainerCardWithAlertAndSuggestions: {
		height: `calc(100vh - ${140 + pendingApprovalAlertHeight + 2 * pendingApprovalAlertBorderWidth + pendingApprovalAlertBottomMargin + suggestionsToggleContainerHeight + suggestionsToggleContainerBottomPadding}px)`,
	},
	calendarContainerCardWithSuggestions: {
		height: `calc(100vh - ${140 + suggestionsToggleContainerHeight + suggestionsToggleContainerBottomPadding}px)`,
	},
	campaignSearch: {
		flexGrow: 1,
	},
	campaignSelector: {
		height: `calc(100vh - 250px)`,
	},
	cardContainer: {
		height: 'calc(100% - 75px)',
	},
	campaignTemplateCardDragging: {
		opacity: 0.95,
	},
	campaignTemplateCardDraggingOverDay: {
		opacity: 0.9,
	},
	contentContainer: {
		display: 'flex',
		boxSizing: 'border-box',
		height: '100%',
		paddingTop: 8,
		gap: 16,
	},
	container: {
		boxSizing: 'border-box',
		height: '100%',
		width: '100%',
	},
	checkboxContent: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: '8px !important',
	},
	filterDropdownContainer: {
		display: 'flex',
		flex: 4,
		flexWrap: 'wrap',
		justifyContent: 'flex-start',
		alignItems: 'flex-end',
		width: '100%',
		gap: 12,
	},
	lastSuggestionRadio: {
		marginLeft: 10,
	},
	newCampaignCta: {
		marginLeft: 24,
		maxHeight: 40,
		minHeight: 40,
	},
	newContentModal: {
		color: titles,
		fontSize: 20,
		width: 420,
	},
	newContentModalBody: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		...Layouts.verticalStack(12),
	},
	newContentModalFooter: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		marginTop: 25,
	},
	newContentModalSubtitle: {
		color: '#4A4A4A',
		fontSize: 14,
	},
	pendingApprovalAlert: {
		alignItems: 'center',
		backgroundColor: hexToRGBA(illusionYellow, 0.25),
		borderColor: illusionYellow,
		borderRadius: 8,
		borderStyle: 'solid',
		borderWidth: pendingApprovalAlertBorderWidth,
		display: 'flex',
		marginBottom: pendingApprovalAlertBottomMargin,
		height: pendingApprovalAlertHeight,
		minHeight: pendingApprovalAlertHeight,
		padding: '0 4px 0 24px',
		gap: 12,
	},

	loadingSuggestionsAlert: {
		alignItems: 'center',
		backgroundColor: THEME.colors.danger.light,
		borderColor: THEME.colors.danger.main,
		borderRadius: 8,
		borderStyle: 'solid',
		borderWidth: pendingApprovalAlertBorderWidth,
		display: 'flex',
		marginBottom: pendingApprovalAlertBottomMargin,
		height: pendingApprovalAlertHeight,
		padding: '0 4px 0 24px',
		gap: 12,
	},
	pendingApprovalAlertButton: {
		...ctaButtonReverseProps(white, brandPrimary),
		backgroundColor: white,
		fontSize: 14,
		padding: '4px 14px',
	},
	pendingApprovalAlertButtonContainer: {
		marginRight: 16,
		marginLeft: 'auto',
	},
	pendingApprovalAlertText: {
		color: titles,
		fontSize: 14,
		marginLeft: 16,
	},
	pendingApprovalText: {
		color: titles,
		fontSize: 12,
		display: 'inline-block',
		marginRight: 10,
	},
	searchContainer: {
		display: 'flex',
		marginBottom: 20,
	},
	suggestionsToggleContainer: {
		...CssSelectors.allChildren(
			{
				minHeight: suggestionsToggleContainerHeight / 2,
			},
			'label'
		),
	},
	suggestionToggleWrap: {
		width: 190,
		marginRight: 16,
	},
	suggestionToggleContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-end',
		width: '100%',
		height: '100%',
	},
	suggestionToggleRow: {
		alignItems: 'center',
	},
	suggestionsToggleText: {
		color: brandPrimary,
		fontSize: 14,
		marginLeft: 6,
	},
	suggestionTypeToggle: {
		display: 'flex',
		fontSize: 12,
		height: suggestionsToggleContainerHeight,
		justifyContent: 'space-between',
		...CssSelectors.allDescendants(
			{
				fontSize: 12,
			},
			'div'
		),
	},
	selectLabel: {
		color: charmGray,
		fontSize: 14,
		marginBottom: 4,
		textTransform: 'uppercase',
		display: 'block',
	},
	campaignTypeLabel: {
		marginBottom: 0,
		display: 'block',
	},
	triggerContainer: {
		display: 'flex',
		height: '100%',
		width: 200,
	},
	triggerContainerCampaignType: {
		width: 125,
	},
	triggerLabel: {
		borderRight: '1px solid rgb(216,216,216)',
		color: '#D1d1d1',
		fontSize: 12,
		letterSpacing: 1.1,
		textTransform: 'uppercase',
		width: 120,
	},
	triggerValue: {
		paddingLeft: 10,
		paddingRight: 5,
	},
	typesKey: {
		background: white,
		padding: 10,
		boxShadow: `0 0 6px 0 ${hexToRGBA(gray4, 0.1)}`,
		borderRadius: 8,
		alignItems: 'center',
		display: 'flex',
		width: '100%',
		marginBottom: 8,
	},
	calendarCardTypeColor: {
		height: 12,
		width: 12,
		borderRadius: '50%',
		marginRight: 4,
		display: 'inline-block',
	},

	ContentCalendarTabs: {
		display: 'flex',
		width: '100%',
		borderBottom: `1px solid ${borderColor}`,
	},
	calendarCardTabItem: {
		padding: '0 12px',
	},
	calendarCardTypeTab: {
		width: '100%',
		height: 44,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: THEME.spacing.xs,
	},
	calendarCardTypeColorEmail: {
		background: green4,
	},
	calendarCardTypeColorSocial: {
		background: spanishBlue,
	},
	calendarCardTypeColorBlog: {
		background: prestoPurple,
	},
	calendarCardTabItemActive: {
		color: THEME.colors.primary.main,
		fontWeight: 600,
		borderBottom: `1px solid ${THEME.colors.primary.main}`,
		...CssSelectors.allChildren({
			color: THEME.colors.primary.main,
		}),
	},
	selectedCount: {
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.main,
	},

	filter: {
		display: 'flex',
		alignItems: 'center',
	},
	selectBoxTrigger: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: 36,
		minWidth: 140,
		whiteSpace: 'nowrap',
		borderRadius: 6,
		border: `1px solid ${borderColor}`,
		backgroundColor: white,
		padding: `8px 12px`,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
		color: titles,
		cursor: 'pointer',
		':focus': {
			outline: 'none',
		},
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
	},
	whiteTriggerBackground: {
		backgroundColor: white,
	},
	selectBoxOption: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		cursor: 'default',
		select: 'none',
		borderRadius: 2,
		paddingTop: 6,
		paddingBottom: 6,
		paddingRight: 32,
		paddingLeft: 8,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		outline: 'none',
		color: darkGrayFontColor,
		':focus': {
			background: brandPrimaryHover,
			color: white,
		},
		':hover': {
			background: brandPrimaryHover,
			color: white,
		},
	},
	noEventSelected: {
		color: titles,
		fontStyle: 'normal',
	},
	showSpan: {
		display: 'none',
		'@media screen and  (min-width: 1332px)': {
			display: 'inline',
		},
	},
	listItem: {
		marginLeft: 8,
	},
	showLabel: {
		fontSize: 14,
		'@media screen and  (min-width: 1270px)': {
			display: 'inline',
		},
	},
	suggestedButton: {
		height: 36,
	},
	pendingApprovalCounts: {
		marginLeft: 32,
		fontSize: 14,
		display: 'flex',
		gap: 12,
	},
	pendingApprovalTypeLink: {
		color: brandPrimary,
		cursor: 'pointer',
		textDecoration: 'none',
		fontSize: 14,
		marginLeft: 4,
		fontWeight: 600,
		':hover': {
			color: brandPrimaryHover,
		},
	},
	appDrawerTemplateBrowserContainer: {
		padding: '24px',
		height: '100%',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		boxSizing: 'border-box',
		'& > *': {
			width: '100%',
			flex: 1,
		},
	},
	suggestedButtonContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	filterAccessoryContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.sm,
		alignItems: 'center',
		justifyContent: 'space-between',
		flex: 1,
	},
});
